import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ActivityItemTypeService from "../../../../Domain/ActivityItemType/ActivityItemType.service";
import NoteSearchFilters from "../../../Presentational/ItemSearchPiece/NoteSearchFilters";
import ActivityFeed from "../../../Presentational/ActivityItem/ActivityFeed";
import ActivityService from "../../../../Services/Activity.service";
import useHasPermission from "../../../Hooks/useHasPermission";
import useCurrentPersonInfo from "../../../Hooks/useCurrentPersonInfo";
const AdvisorStudentsStudentNotesTab = (props) => {
    const [noteSearch, setNoteSearch] = React.useState(null);
    const canSeeOthersNotes = useHasPermission("CAN_SEE_NOTES_CREATED_BY_OTHERS");
    const currentPerson = useCurrentPersonInfo();
    const itemSearch = React.useMemo(() => {
        var _a, _b, _c, _d, _e, _f;
        if (canSeeOthersNotes == null || currentPerson.data == null) {
            return null;
        }
        const currentUserId = currentPerson.data.person.id;
        if (noteSearch) {
            return {
                global: {
                    activityItemTypeIds: [ActivityItemTypeService.NoteId],
                    createdByPeoplePersonIds: canSeeOthersNotes
                        ? (_a = noteSearch.creators) === null || _a === void 0 ? void 0 : _a.map((creator) => creator.personId)
                        : [currentUserId],
                    createdDateFrom: noteSearch.createdDateFrom,
                    createdDateTo: noteSearch.createdDateTo,
                    contextPeoplePersonIds: [props.student.personId],
                    pipelineIds: (_b = noteSearch.pipelines) === null || _b === void 0 ? void 0 : _b.map((pipeline) => pipeline.id),
                },
                latestValue: [
                    {
                        types: (_c = noteSearch.noteTypes) === null || _c === void 0 ? void 0 : _c.map((noteType) => noteType.id),
                        updatedDateFrom: noteSearch.updatedDateFrom,
                        updatedDateTo: noteSearch.updatedDateTo,
                    },
                ],
            };
        }
        return {
            global: {
                contextPeoplePersonIds: [props.student.personId],
                activityItemTypeIds: [ActivityItemTypeService.NoteId],
                createdByPeoplePersonIds: canSeeOthersNotes ? null : [currentUserId],
                pipelineIds: props.opportunity && [
                    (_f = (_e = (_d = props.opportunity) === null || _d === void 0 ? void 0 : _d.stage) === null || _e === void 0 ? void 0 : _e.pipeline) === null || _f === void 0 ? void 0 : _f.id,
                ],
            },
            latestValue: [],
        };
    }, [
        canSeeOthersNotes,
        currentPerson.data,
        noteSearch,
        props.student.personId,
        props.opportunity,
    ]);
    const poll = React.useCallback(() => ActivityService.areThereRecentEventsForPerson(props.student.personId), [props.student.personId]);
    return (_jsx(ActivityFeed, { search: itemSearch, poll: poll, filterComponent: _jsx(NoteSearchFilters, { onSearch: setNoteSearch, opportunity: props.opportunity }) }));
};
export default AdvisorStudentsStudentNotesTab;
